import { render, staticRenderFns } from "./ui-breadcrumbs.vue?vue&type=template&id=a09a0cb8&scoped=true&"
import script from "./ui-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ui-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ui-breadcrumbs.vue?vue&type=style&index=0&id=a09a0cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a0cb8",
  null
  
)

export default component.exports